module.exports = __webpack_public_path__ + "img/verde_11_11_a.99d48489.jpg";